import { SidebarMenuButton, Card } from '@bpinternal/ui-kit-next'
import { useSuspenseQuery as useTanstackSuspenseQuery } from '@tanstack/react-query'
import classNames from 'classnames'
import { ChevronsUpDown } from 'lucide-react'
import { ComponentProps, useState } from 'react'
import { DropdownMenu, MenuItem } from '~/elements'
import { listBotsQueryOptions } from '~/queries'
import { cn } from '~/utils'
import { BotIcon } from './BotIcon'

type Props = {
  workspaceId: string
  selectedBotId?: string
  onChange?: (botId: string) => void
} & Omit<ComponentProps<typeof Card>, 'onChange'>

export const UsageBotSelector = ({ workspaceId, selectedBotId, onChange, ...props }: Props) => {
  const [_selectedBotId, setSelectedBotId] = useState<string | undefined>(selectedBotId)

  function handleOnChange(botId: string) {
    setSelectedBotId(botId)
    onChange?.(botId)
  }
  const bots = useTanstackSuspenseQuery(listBotsQueryOptions(workspaceId)).data

  const botMenuItems: MenuItem[] = [
    {
      type: 'radioGroup',
      value: _selectedBotId,
      items:
        bots
          ?.map((bot) => {
            return {
              content: bot.name,
              type: 'radioItem' as const,
              value: bot.id,
              onSelect: () => handleOnChange(bot.id),
              leadingIcon: <BotIcon id={bot.id} size={'2'} />,
            }
          })
          .sort((a, b) => a.content.localeCompare(b.content)) ?? [],
    },
  ]

  return (
    <Card {...props} className={classNames('-my-px flex items-center gap-1 rounded-sm p-1', props.className)}>
      <DropdownMenu disabled={!bots.length} content={botMenuItems} align="start">
        <SidebarMenuButton className={cn(!selectedBotId && 'justify-between')} size={'sm'} tooltip="Select a bot">
          {selectedBotId ? (
            <>
              <BotIcon id={selectedBotId} size="1" />
              <span className="truncate text-sm">{bots.find((bot) => bot.id === selectedBotId)?.name}</span>
              <ChevronsUpDown className="ml-auto" />
            </>
          ) : (
            <>
              <span className="mr-3 truncate group-data-[collapsible=icon]:hidden">Select a bot...</span>
              <ChevronsUpDown />
            </>
          )}
        </SidebarMenuButton>
      </DropdownMenu>
    </Card>
  )
}
